/* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

import { SalesLedgerState, SalesLedgerStateRecord } from "./ledger.state";
import * as actions from '../ledger-action/ledger.action';
/**
 
import {   SalesPaymentStateRecord } from '../payments-reducer/payments.state';

 */
export const initialState: SalesLedgerState = new SalesLedgerStateRecord() as unknown as SalesLedgerState;

export function reducer(
  state = initialState, { 
    type, payload 
  }: any
): SalesLedgerState {
  if (!type) {
    return state;
  }

  switch (type) {

    // <------------------LEDGER LIST--------------------> //

    case actions.ActionTypes.GET_LEDGER_LIST_ACTION: {
      return Object.assign({}, state, {
        ledgerList: [],
        ledgerLoading: true,
        ledgerListLoaded: false,
        ledgerListFailed: false,
      });
    }

    case actions.ActionTypes.GET_LEDGER_LIST_SUCCESS: {
      return Object.assign({}, state, {
        ledgerList: payload,
        ledgerListLoading: false,
        ledgerListLoaded: true,
        ledgerListFailed: false,
      });
    }

    case actions.ActionTypes.GET_LEDGER_LIST_FAIL: {
      return Object.assign({}, state, {
        ledgerList: [],
        ledgerListLoading: false,
        ledgerListLoaded: false,
        ledgerListFailed: true,
      });
    }

    default: {
      return state;
    }
  }
}

export const ledgerList = (state: SalesLedgerState) => state.ledgerList;
export const ledgerListLoading = (state: SalesLedgerState) => state.ledgerListLoading;
export const ledgerListLoaded = (state: SalesLedgerState) => state.ledgerListLoaded;
export const ledgerListFailed = (state: SalesLedgerState) => state.ledgerListFailed;